import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { cn } from '@bem-react/classname'

import './Back.scss'

interface IBackProps {
  className?: string
  url?: string
  onClick?: () => void
}

const cnBack = cn('Back')

export const Back: FC<IBackProps> = ({ className, url, onClick }) => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (onClick) {
      onClick()
      return
    }
    if (url) {
      navigate(url)
    } else {
      navigate(-1)
    }
  }

  return (
    <button
      type='button'
      onClick={handleGoBack}
      className={cnBack(null, [className])}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
      >
        <path
          d='M5.83325 14H22.1666M5.83325 14L12.8333 7M5.83325 14L12.8333 21'
          stroke='#A867FC'
          stroke-width='1.75'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </button>
  )
}
